import { render, staticRenderFns } from "./HomeRefAziendale.vue?vue&type=template&id=0a7181a8&scoped=true"
import script from "./HomeRefAziendale.vue?vue&type=script&lang=js"
export * from "./HomeRefAziendale.vue?vue&type=script&lang=js"
import style0 from "./HomeRefAziendale.vue?vue&type=style&index=0&id=0a7181a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7181a8",
  null
  
)

export default component.exports